import {PaymentSegmentValue} from '../types/PaymentSegmentValue';

export const isSegmentValue = (val: string): val is PaymentSegmentValue =>
  val === 'detail' || val === 'payments';
